<mat-toolbar>
  <span class="breadcrumb" routerLink="/adherents">
    <span>{{'Adhérents' | uppercase}}</span>
  </span>
  <mat-icon>chevron_right</mat-icon>
  @if (adherent) {
  <span class="highlight">
    {{ adherent.nom | uppercase }}
  </span>
  }
  <span class="spacer"></span>
</mat-toolbar>


<div class="content">
  <mat-form-field appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [ngModel]="globalFilter" (ngModelChange)="applyFilter($event)" #input />
    @if (globalFilter) {
    <button matSuffix mat-icon-button class="close-button" aria-label="Clear" (click)="applyFilter(globalFilter = '')">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>

  @if (!!dataSource.data) {
  <div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <!-- Code user Column -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
        <td mat-cell *matCellDef="let element"> {{element.code}} </td>
      </ng-container>
      <!-- Name Column -->
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom </th>
        <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
      </ng-container>
      <!-- Firstname Column -->
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prénom </th>
        <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
      </ng-container>
      <!-- Mail Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Mail </th>
        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox (click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()"
            (change)="selectHandler(element)" [checked]="adherentsUserSelected.isSelected(element)">
          </mat-checkbox>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" colspan="12">Aucune donnée correspondant au filtre "{{input.value}}"</td>
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons>
    </mat-paginator>
  </div>
  }

  <div class="buttons-container">
    <span class="spacer"></span>
    <button mat-raised-button (click)="onSave()">
      <mat-icon>save</mat-icon>
      <span>ENREGISTRER</span>
    </button>
  </div>
</div>